module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/blackClose.26983f19.svg";